import { RIGHT_CURSOR_URL } from "../reader/components/horizontalReading/icons";

// Extract the raw base64 PNG out of the reader's RIGHT_CURSOR_URL so we can
// reuse the same arrow art, rotated, for the vertical-feed cursors.
const PNG_MATCH = RIGHT_CURSOR_URL.match(
  /url\((data:image\/png;base64,[^)]+)\)/,
);
const PNG_DATA = PNG_MATCH?.[1] ?? "";

function rotatedCursorSvg(deg: number): string {
  // Embed the original PNG inside a 32x32 SVG, rotated around the center.
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"><image href="${PNG_DATA}" width="32" height="32" transform="rotate(${deg} 16 16)"/></svg>`;
  return encodeURIComponent(svg);
}

export const UP_CURSOR_URL = `url("data:image/svg+xml;utf8,${rotatedCursorSvg(-90)}") 16 16, n-resize`;
export const DOWN_CURSOR_URL = `url("data:image/svg+xml;utf8,${rotatedCursorSvg(90)}") 16 16, s-resize`;
